import angular from 'angular';
import { APIConstructor } from '@knitiv/api-client-javascript';

class APIWrapperV5Helper {
	constructor() {
		this.api = new APIConstructor();

		this.api.emitter.on('error', (/** @type {any} */ eventError) => {
			const { error, id } = eventError;

			const ignoreList = [
				'load-schema-node-from-k',
			];

			if (id && ignoreList.includes(id)) {
				return false;
			}

			// let's ignore load-schema-node-from-k request
			const User = this.$injector?.get('User');

			if (error.errno === 'NO_TOKEN') {
				return User.logout(error.errno);
			}

			if (error.errno === 'PASSWORD_MUST_CHANGE') {
				return User.logout(error.errno);
			}

			const Notification = this.$injector?.get('Notification');

			Notification.error({
				title: error.errno,
				message: error.errno_desc,
			});

			return false;
		});

		this.api.emitter.on('beforeRequest', (/** @type {any} */ request) => {
			if (request && request.options && !request.options.id) {
				console.error(`API call "${request.resource}" has no "id" context value. Please specify one.`);
			}
		});

		this.api.emitter.on('retry', (/** @type {any} */ {
			nextAttempt,
			attemptNumber,
			retry: maxRetries,
		}) => {
			const Notification = this.$injector?.get('Notification');
			const $translate = this.$injector?.get('$translate');
			const $filter = this.$injector?.get('$filter');

			if (attemptNumber > (maxRetries ?? 0)) {
				Notification.error({
					title: $translate.instant('error.title'),
					message: $translate.instant('error.network-disconnected'),
					replaceMessage: true,
				});
			}
			else if ($filter) {
				Notification.warning({
					title: $translate.instant('error.unable-to-process'),
					message: $filter('sprintf')(
						$translate.instant('error.network-attempt'),
						attemptNumber,
						maxRetries,
						nextAttempt / 1000,
					),
				});
			}
		});
	}

	/**
	 * @returns {import('@knitiv/api-client-javascript').APIConstructor}
	 */
	get instance() {
		return this.api;
	}

	/**
	 *
	 * @param {angular.auto.IInjectorService} injector
	 */
	setInjector(injector) {
		this.$injector = injector;
	}
}

const api = new APIWrapperV5Helper();

export default api;
